import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import { Guid } from "../../../api/baseApi";
import { getMosaicSingle, MosaicElement, MosaicElementType, postMosaicNewElements, uploadImage, IMediaLoopItem, MosaicElementsArrayAddRequest } from "../../../api/mosaicApi";
import { formatDateTime,  } from "../../../services/dateService";
import { sunbScribeOnClick, unsubscribe } from "../../../services/globalEventHandler";
import { Button } from "../../components/Button";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import { FormInput, FormInputColorpicker, FormInputNumber, FormRow, FormSelect, SelectOption } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import SelectFileButton, { SelectAvatarButton } from "../../components/selectFileButton/SelectFileButton";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import InnerLayout from "../innerLayout/InnerLayout";
import { WeatherWidget, WeatherWidgetData, WeatherWidgetListItem } from './widgets';
import './MosaicScreen.css'

interface MosaicScreenProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

interface IMosaicConfig {
    name: string,
    gridColumnWidth: string,
    gridColumnHeight: string,
    columnNumber: number,
    rowNumber: number
}

const mosaicContainer: IMosaicConfig = {
    name: 'My',
    gridColumnWidth: '1fr',
    gridColumnHeight: '100px',
    columnNumber: 7,
    rowNumber:2,
}

interface MosaiScreenParams {
    skinId: Guid
}

interface MosaicElementPreview extends MosaicElement {
    staticImageUrl?: string,
    mediaLoopMediasInfo?: IMediaLoopItem[],
    indexForBacklight?: Guid,
}

const FontFamilies:SelectOption[] = [
    { name: 'Arial', value: '0' },
    { name: 'Poppins', value: '1' },
    { name: 'Times New Roman', value: '2' },
    { name: 'Helvetica', value: '3' },
    { name: 'Courier New', value: '4' },
    { name: 'Verdana', value: '5' },
    { name: 'Tahoma', value: '6' },
    { name: 'Georgia', value: '7' },
    { name: 'Segoe UI', value: '8' },
    { name: 'Roboto', value: '9' },
    { name: 'San Francisco', value: '10' },
    { name: 'Inter', value: '11' },
    { name: 'Montserrat', value: '12' },
    { name: 'Open Sans', value: '13' },
    { name: 'Lato', value: '14' },
    { name: 'Futura', value: '15' },
    { name: 'Garamond', value: '16' }
];

const FontStyles:SelectOption[] = [
    { name: 'Normal', value: '0' },
    { name: 'Italic', value: '1' },
    { name: 'Bold', value: '2' },
    { name: 'Bold Italic', value: '3' }
];

const TextAlignments:SelectOption[] = [
    { name: 'Left', value: '0' },
    { name: 'Center', value: '1' },
    { name: 'Right', value: '2' },
    { name: 'Justify', value: '3' }
];

const HeaderFontSizes:SelectOption[] = [
    { name: '12', value: '12' },
    { name: '14', value: '14' },
    { name: '16', value: '16' },
    { name: '18', value: '18' },
    { name: '20', value: '20' },
    { name: '22', value: '22' },
    { name: '24', value: '24' },
    { name: '26', value: '26' },
    { name: '28', value: '28' },
    { name: '30', value: '30' },
    { name: '32', value: '32' },
    { name: '36', value: '36' },
    { name: '40', value: '40' },
    { name: '44', value: '44' },
    { name: '48', value: '48' },
    { name: '52', value: '52' },
    { name: '56', value: '56' },
    { name: '60', value: '60' },
    { name: '64', value: '64' },
    { name: '68', value: '68' },
    { name: '72', value: '72' }
];

const TextFontSizes:SelectOption[] = [
    { name: '10', value: '10' },
    { name: '12', value: '12' },
    { name: '14', value: '14' },
    { name: '16', value: '16' },
    { name: '18', value: '18' },
    { name: '20', value: '20' },
    { name: '22', value: '22' },
    { name: '24', value: '24' },
    { name: '26', value: '26' },
    { name: '28', value: '28' },
    { name: '30', value: '30' },
    { name: '32', value: '32' },
    { name: '36', value: '36' },
    { name: '40', value: '40' },
    { name: '44', value: '44' },
    { name: '48', value: '48' }
];

const TimeFormats:SelectOption[] = [
    {
        name: '14:12:19, 06.09.2022',
        value: 'HH:mm:ss, dd.MM.yyyy'
    },
    {
        name:'02:12 PM',
        value:'hh:mm tt'
    },
    {
        name:'14:12',
        value:'HH:mm'
    },
    {
        name:'14:12:19',
        value:'HH:mm:ss'
    },
    {
        name:'02:12:19 PM',
        value:'hh:mm:ss tt'
    },
    {
        name:'02/12/19 PM, 06/09/2022',
        value:'hh/mm/ss tt, dd/MM/yyyy'
    },
    {
        name:'Tuesday, September 6, 2022 2:12 PM',
        value:'f'
    },
    {
        name:'Tuesday, September 6, 2022 2:12:19 PM',
        value:'F'
    },
]

let mockUploadedLoopImage:IMediaLoopItem = {
    id:'1',
    name: 'Test'
}

const MosaicScreen: FunctionComponent<MosaicScreenProps> = (props) => {
    let {logOut, toogleCollapse, isCollapsed} = props;

    let [mosaicConfig, setMosaicConfig] = useState<IMosaicConfig>(mosaicContainer);
    let [idForBackLight, setIdForBackLight] = useState<Guid>('');
    let [uploadedImageName, setUploadedImageName] = useState('');
    let [uploadedImageUrl, setUploadedImageUrl] = useState('');
    let [uploadedMediaLoopImage, setUploadedMediaLoopImage] = useState<IMediaLoopItem>(mockUploadedLoopImage);

    let [columnStart, setColumnStart] = useState<number | string>(1);
    let [width, setWidth] = useState<number | string>(1);
    let [rowStart, setRowStart] = useState<number | string>(1);
    let [height, setHeight] = useState<number | string>(1);
    let [selectedElementType, setSelectedElementType] = useState<MosaicElementType>(MosaicElementType.Main);
    let [currentClickedPositionIndex, setCurrentClickedPositionIndex] = useState(1);
    let [chekedCellsNumber, setCheckedCellsNumber] = useState(0);

    let [bgColor, setBgColor] = useState('#ffffff');
    let [textColor, setTextColor] = useState('#000000');

    let [selectedTimeFormat, setSelectedTimeFormat] = useState('HH:mm:ss, dd.MM.yyyy');

    let [rssNumberOfLines, setRssNumberOfLines] = useState<number | string>(1);
    let [rssMaxItems, setRssMaxItems] = useState<number | string>(1);
    let [rssHeaderColor, setRssHeaderColor] = useState('#ffffff');
    let [rssTextColor, setRssTextColor] = useState('#000000');
    let [rssBackgroundImageRecourceBlobName, setRssBackgroundImageRecourceBlobName] = useState('');
    let [rssBackgroundImageUrl, setRssBackgroundImageUrl] = useState('');
    let [rssFallbackImageRecourceBlobName, setRssFallbackImageRecourceBlobName] = useState('');
    let [rssFallbackImageUrl, setRssFallbackImageUrl] = useState('');
    
    // RSS Typography - Header
    let [rssHeaderFont, setRssHeaderFont] = useState<number>(1);
    let [rssHeaderFontSize, setRssHeaderFontSize] = useState<number>(24);
    let [rssHeaderFontStyle, setRssHeaderFontStyle] = useState<number>(0);
    let [rssHeaderAlignment, setRssHeaderAlignment] = useState<number>(0);
    
    // RSS Typography - Text
    let [rssTextFont, setRssTextFont] = useState<number>(1);
    let [rssTextFontSize, setRssTextFontSize] = useState<number>(16);
    let [rssTextFontStyle, setRssTextFontStyle] = useState<number>(0);
    let [rssTextAlignment, setRssTextAlignment] = useState<number>(0);
    let [rssHideText, setRssHideText] = useState<boolean>(false);
    
    // RSS Margins and Spacing
    let [rssMarginTop, setRssMarginTop] = useState<number | string>(10);
    let [rssMarginRight, setRssMarginRight] = useState<number | string>(10);
    let [rssMarginLeft, setRssMarginLeft] = useState<number | string>(10);
    let [rssSpacingBetweenTextAndHeader, setRssSpacingBetweenTextAndHeader] = useState<number | string>(5);
    let [rssSpacingBetweenItems, setRssSpacingBetweenItems] = useState<number | string>(10);
    
    // RSS Update and Rotation Settings
    let [rssUpdateIntervalMinutes, setRssUpdateIntervalMinutes] = useState<number | string>(30);
    let [rssRotationIntervalSeconds, setRssRotationIntervalSeconds] = useState<number | string>('');
    let [rssRotateInRandom, setRssRotateInRandom] = useState<boolean>(false);
    let [rssLoadLastXHours, setRssLoadLastXHours] = useState<number | string>('');

    // Weather Background Image
    let [weatherBackgroundImageUrl, setWeatherBackgroundImageUrl] = useState('');

    let [mosaicValidationErrorText, setMosaicValidationErrorText] = useState('');

    let [imageDuration, setImageDuration] = useState(10);
    let [isPlaylistVideoDownloaded, setIsPlaylistVideoDownloaded] = useState(false);
    let [isPlaylistMediaDownloaded, setIsPlaylistMediaDownloaded] = useState(false);
    let [mediaLoopList, setMediaLoopList] = useState<IMediaLoopItem[]>([]);
    let [mute, setMute] = useState(true);
    let [youtubeIsLive, setYoutubeIsLive] = useState(true);

    let [nameElement, setNameElement] = useState('');
    let [youtubeURL, setYoutubeURL] = useState('');

    let [isLoading, setIsLoading] = useState(false);

    let [mosaicVideoLayer, setMosaicVideoLayer] = useState<MosaicElementPreview[]>([]);
    let [mosaicWidgetLayer, setMosaicWidgetLayer] = useState<MosaicElementPreview[]>([]);
    let [isMosaicElementsChange, setIsMosaicElementsChange] = useState(false);

    let [zipFileName, setZipFileName] = useState<string>("");
    let [isLocal, setIsLocal] = useState(true)

    let {skinId: mosaicId} = useParams<MosaiScreenParams>();

    const mosaicRef = useRef<HTMLDivElement>(null);

    useEffect(()=>{
        async function fetchData() {
            setIsLoading(true);
            await Promise.all([getMosaicDataSingle()])
            setIsLoading(false);
        };
        fetchData();

        sunbScribeOnClick(()=>{
            setIdForBackLight('');
        }, "mosaic")

        return ()=>{
            unsubscribe("mosaic");
        }
    },[])

    useEffect(()=>{
        let maxWidth:number = mosaicConfig.columnNumber, maxHeight: number = mosaicConfig.rowNumber;
        if(typeof columnStart == 'number'){
            maxWidth = mosaicConfig.columnNumber - columnStart + 1;
            if(columnStart > mosaicConfig.columnNumber) setColumnStart(mosaicConfig.columnNumber);
        }
        if(typeof width == 'number'){
            if(width > maxWidth) setWidth(maxWidth);
        }
        if(typeof rowStart == 'number'){
            maxHeight = mosaicConfig.rowNumber - rowStart + 1;
            if(rowStart > mosaicConfig.rowNumber) setRowStart(mosaicConfig.rowNumber);
        }
        if(typeof height == 'number'){
            if(height > maxHeight) setHeight(maxHeight);
        }
        setMosaicValidationErrorText('');
        if(columnStart == "" || width == "" || rowStart == "" || height == ""){
            setMosaicValidationErrorText('Position coordinates can not be empty');
        }
    },[columnStart, rowStart, width, height]);

    useEffect(()=>{
        if(imageDuration < 0) setImageDuration(0);
    },[imageDuration])

    const getElementLimits = (type: MosaicElementType) => {
        switch(type) {
            case MosaicElementType.Main : return 1
            case MosaicElementType.Image: return 10
            case MosaicElementType.Clock: return 5
            case MosaicElementType.MediaLoop: return 3
            case MosaicElementType.Youtube: return 3
            case MosaicElementType.WebView: return 3
            case MosaicElementType.WebViewLocal: return 3
            case MosaicElementType.Rss: return 3
            case MosaicElementType.Weather: return 3
        }
    }

    const getMosaicElementTypeName = (contentType: MosaicElementType) => {
        switch(contentType){
            case MosaicElementType.Main : return 'Main';
            case MosaicElementType.Image : return 'Image';
            case MosaicElementType.Clock : return 'Clock';
            case MosaicElementType.MediaLoop : return 'Playlist';
            case MosaicElementType.Youtube : return 'Youtube';
            case MosaicElementType.WebView : return 'WebView';
            case MosaicElementType.WebViewLocal : return 'WebView Local';
            case MosaicElementType.Rss : return 'RSS';
            case MosaicElementType.Weather : return 'Weather';
        }
    }
    
    const getIconByType = (type: MosaicElementType) => {
        switch(type) {
            case MosaicElementType.Main : return <SvgSelector title={`mosaic`}/>
            case MosaicElementType.Image: return <SvgSelector title={`image`}/>
            case MosaicElementType.Clock: return <SvgSelector title={`clock`}/>
            case MosaicElementType.MediaLoop: return <SvgSelector title={`list-add`}/>
            case MosaicElementType.Youtube: return <SvgSelector title={`youtube`}/>
            case MosaicElementType.WebView: return <SvgSelector title={`webview`}/>
            case MosaicElementType.WebViewLocal: return <SvgSelector title={`webview`}/>
            case MosaicElementType.Rss: return <SvgSelector title={`list-add`}/>
            case MosaicElementType.Weather: return <SvgSelector title={`weather`}/>
        }
    }

    const getElementsCountByType = (type: MosaicElementType) => [...mosaicVideoLayer, ...mosaicWidgetLayer].filter(it => it.type === type).length;
    const isElementOutOfLimit = (type: MosaicElementType) =>  getElementsCountByType(type) >= getElementLimits(type);
    const getTimeFormatName = (format:string | undefined) => TimeFormats.find(it => it.value === format)?.name;
    const checkIsVideoLayerElement = (type: MosaicElementType) =>  type == MosaicElementType.Main || type == MosaicElementType.MediaLoop;

    const getMosaicDataSingle = async () => {
        setIsLoading(true);
        let result = await getMosaicSingle(mosaicId);

        if(result.type === "succes") {
            let totalWidth = mosaicRef.current?.offsetWidth;
            let gridColumnWidth = (totalWidth ? totalWidth : 1) / result.data.data.columnsCount;
            setMosaicConfig({...mosaicConfig,
                name: result.data.data.name,
                gridColumnWidth: gridColumnWidth+'px',
                gridColumnHeight: gridColumnWidth+'px',
                columnNumber: result.data.data.columnsCount,
                rowNumber: result.data.data.rowsCount
            })
            let t1 : MosaicElement[] = [], t2 : MosaicElement[] = [];
            result.data.data.elements.filter(el => {
                if(checkIsVideoLayerElement(el.type)) t1.push(el)
                else t2.push(el)
            })
            setMosaicVideoLayer(t1);
            setMosaicWidgetLayer(t2);
        }
        setIsLoading(false);
    }

    const clickForBacklightCell = (id:Guid) => {
        if(idForBackLight === id) {
            setIdForBackLight('');
        } else {setIdForBackLight(id)}
    }

    const renderMosaicElements = (mosaic:MosaicElementPreview[]) => {
        return mosaic.map( (it) => {
            let isForBacklight, curIdentifier: Guid
            if(it.id != ""){
                isForBacklight = it.id === idForBackLight;
                curIdentifier = it.id
            } else {
                isForBacklight = it.indexForBacklight === idForBackLight
                curIdentifier = it.indexForBacklight === undefined ? '' : it.indexForBacklight
            }
            let topLevelPosition = it.type == MosaicElementType.Main ? "z1000" : "";
            let cellClassnames = `saved-cell ${isForBacklight && 'backlight'} ${topLevelPosition}`;
            return <div className={cellClassnames} onClick={()=> {clickForBacklightCell(curIdentifier)}} key={curIdentifier} style={{
                ['--column-start']:`${it.startColumn}`, 
                ['--column-end']:`${it.startColumn + it.width}`, 
                ['--row-start']:`${it.startRow}`, 
                ['--row-end']:`${it.startRow + it.height}`,
            }as React.CSSProperties}>
                {it.type === MosaicElementType.Image && <img className="mosaic-img" src={it.staticImageUrl} alt="" />}
                {it.type === MosaicElementType.Main && <span className="txt">Main</span>}
                {it.type === MosaicElementType.Clock && <span className="mosaic-clock" style={{
                    ['--bg-color']:`${it.clockBackgroundColour}`,
                    ['--text-color']:`${it.clockTextColour}`
                }as React.CSSProperties}><span className="txt">
                    {formatDateTime(new Date().toISOString(), it.clockTextFormat)}
                    </span>
                </span> }
                {it.type === MosaicElementType.MediaLoop && <ol className="txt medialoop">
                    {it.mediaLoopMedias?.map(it => <li key={it.id}>{it.name}</li>)}
                    </ol>}
                {it.type === MosaicElementType.Youtube && <span className="txt">YouTube</span>}
                {it.type === MosaicElementType.WebView && <span className="txt">WebView: {it.name}<br/>{it.url}</span>}
                {it.type === MosaicElementType.WebViewLocal && <span className="txt">WebView Local: {it.name}</span>}
                {it.type === MosaicElementType.Rss && <span className="txt" style={{
                    ...(it.parameters?.type === 'rss' && it.parameters.backgroundImageUrl ? {
                        backgroundImage: `url(${it.parameters.backgroundImageUrl})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } : {})
                }}>RSS<br/>{it.parameters?.type === 'rss' ? it.parameters.url : it.url}</span>}
                {it.type === MosaicElementType.Weather && <span className="txt" style={{
                    ...(it.parameters?.type === 'weather' && it.parameters.backgroundImageUrl ? {
                        backgroundImage: `url(${it.parameters.backgroundImageUrl})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } : {})
                }}>Weather: {it.parameters?.type === 'weather' && it.parameters.city}</span>}
            </div>
        })
    }

    const renderElementPositionPreview = () => {
        return <div className="demo-cell" style={{
                ['--column-start']:`${columnStart}`, 
                ['--column-end']:`${+columnStart + +width}`, 
                ['--row-start']:`${rowStart}`, 
                ['--row-end']:`${+rowStart + +height}`,
                ...(selectedElementType === MosaicElementType.Rss && rssBackgroundImageUrl ? {
                    backgroundImage: `url(${rssBackgroundImageUrl})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                } : {}),
                ...(selectedElementType === MosaicElementType.Weather && weatherBackgroundImageUrl ? {
                    backgroundImage: `url(${weatherBackgroundImageUrl})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                } : {})
            }as React.CSSProperties}>
                {!!uploadedImageUrl ? <img className="mosaic-img" src={uploadedImageUrl} alt="" /> : <span className="txt">Preview</span>}
            </div>
    }

    const calcStartPosition = (posIndex: number) => {
        if(chekedCellsNumber != 1){
            setCurrentClickedPositionIndex(posIndex);
            setColumnStart(posIndex % mosaicConfig.columnNumber === 0 ? mosaicConfig.columnNumber : posIndex % mosaicConfig.columnNumber);
            setRowStart(Math.ceil(posIndex/mosaicConfig.columnNumber));
            setCheckedCellsNumber(++chekedCellsNumber);
            setWidth(1);
            setHeight(1);
        }
        else {
            setCheckedCellsNumber(0);
        }
    }

    const calcEndPosition = (posIndex: number) => {
        if(chekedCellsNumber === 1) {
            let minColumnStart;
            let maxColumnStart;

            let hoverPositionColumn = posIndex % mosaicConfig.columnNumber === 0 ? mosaicConfig.columnNumber : posIndex % mosaicConfig.columnNumber;

            if( currentClickedPositionIndex % mosaicConfig.columnNumber != 0 ) {
                minColumnStart = Math.min(currentClickedPositionIndex % mosaicConfig.columnNumber, hoverPositionColumn);
            } else {
                minColumnStart = hoverPositionColumn;
            }
            
            if(currentClickedPositionIndex % mosaicConfig.columnNumber != 0 ){
                maxColumnStart = Math.max(currentClickedPositionIndex % mosaicConfig.columnNumber, hoverPositionColumn);
            } else {
                maxColumnStart =  mosaicConfig.columnNumber;
            }
            
            let minRowStart = Math.min(Math.ceil(currentClickedPositionIndex/mosaicConfig.columnNumber), Math.ceil(posIndex/mosaicConfig.columnNumber));
            let maxRowStart = Math.max(Math.ceil(currentClickedPositionIndex/mosaicConfig.columnNumber), Math.ceil(posIndex/mosaicConfig.columnNumber));

            let currentWidth = maxColumnStart - minColumnStart + 1;
            let currentHeight = maxRowStart - minRowStart + 1;
            
            setColumnStart(minColumnStart);
            setRowStart(minRowStart);
            setWidth(currentWidth);
            setHeight(currentHeight);
        }
    }

    const renderMosaicCells = (columns: number,rows: number) => {
        let arr:number[] = [];
        let q = columns * rows;       

        if( q > 8000) return <></>

        for(let i = 1; i<=q; i++){
            arr.push(i)
        }
        let skipRows = 1;
        let skipColumns = 1;
        if(rows > 30) skipRows = 5;
        if(rows > 100) skipRows = 10;
        if(columns > 50) skipColumns = 5;
        if(columns > 100) skipColumns = 10;

        return arr.map( (it:any, index:number) => {
            if(index < columns){
                if(index === 0){
                    return <div key={index} onClick={()=>calcStartPosition(it)} onMouseEnter={()=>calcEndPosition(it)}>
                        {skipRows==1 && <span className="index-cell y">{it}</span>}
                        {skipColumns==1 && <span className="index-cell x">{it}</span>}
                    </div>
                }

                let showColumnNumber = it % skipColumns == 0;
                return <div key={index} onClick={()=>calcStartPosition(it)} onMouseEnter={()=>calcEndPosition(it)}>
                    {showColumnNumber && <span className="index-cell x">{it}</span>}
                </div>
            }
            if(index % columns === 0){
                let rowNumber = index/columns + 1;
                let showRowNumber =  rowNumber % skipRows == 0;
                return <div key={index} onClick={()=>calcStartPosition(it)} onMouseEnter={()=>calcEndPosition(it)}>
                    {showRowNumber && <span className="index-cell y">{rowNumber}</span> }
                </div>
            } 
            return <div key={index} onClick={()=>calcStartPosition(it)} onMouseEnter={()=>calcEndPosition(it)}></div>
        })
    }

    const updateMosaicTemplate = async () => {
        let allMosaicElements = [...mosaicVideoLayer, ...mosaicWidgetLayer];
        let mainElement = allMosaicElements.find(it => it.type === MosaicElementType.Main);

        if(!mainElement){
            setMosaicValidationErrorText("Main Element should be exist")
            return
        }

        let newMosaicElements: MosaicElementsArrayAddRequest = {
            elements: allMosaicElements.map( el => {
                if(el.id == ""){
                    delete el.indexForBacklight
                }
                return {...el, id : el.id == "" ? null : el.id}
            })
        }; 
            
        setMosaicVideoLayer([]);
        setMosaicWidgetLayer([]);
        await postMosaicNewElements(newMosaicElements, mosaicId);
        await getMosaicDataSingle();

        setColumnStart(1);
        setWidth(1);
        setRowStart(1);
        setHeight(1);
        setUploadedImageName('');
        setUploadedImageUrl('');
        setBgColor('#ffffff');
        setTextColor('#000000');
        setSelectedTimeFormat('HH:mm:ss, dd.MM.yyyy');
        setRssNumberOfLines(1);
        setRssMaxItems(1);
        setRssHeaderColor('#ffffff');
        setRssTextColor('#000000');
        setRssBackgroundImageRecourceBlobName('');
        setRssBackgroundImageUrl('');
        setRssFallbackImageRecourceBlobName('');
        setRssFallbackImageUrl('');
        // Reset RSS Typography - Header
        setRssHeaderFont(0);
        setRssHeaderFontSize(24);
        setRssHeaderFontStyle(0);
        setRssHeaderAlignment(0);
        // Reset RSS Typography - Text
        setRssTextFont(0);
        setRssTextFontSize(16);
        setRssTextFontStyle(0);
        setRssTextAlignment(0);
        setRssHideText(false);
        // Reset RSS Margins and Spacing
        setRssMarginTop(10);
        setRssMarginRight(10);
        setRssMarginLeft(10);
        setRssSpacingBetweenTextAndHeader(5);
        setRssSpacingBetweenItems(10);
        // Reset RSS Update and Rotation Settings
        setRssUpdateIntervalMinutes(30);
        setRssRotationIntervalSeconds('');
        setRssRotateInRandom(false);
        setRssLoadLastXHours('');
        setMediaLoopList([]);
        setNameElement('');
        setYoutubeURL('');
        setMute(true);
        setYoutubeIsLive(true);
        setIsMosaicElementsChange(false);
        setZipFileName("");
        setIsLocal(true)
    }

    const addLocalNewMosaicElem = async () => {
        const normalizedRssLines = Math.max(1, Math.floor(+rssNumberOfLines || 1));
        const normalizedRssMaxItems = Math.max(1, Math.floor(+rssMaxItems || 1));
        let newMosaicElement:MosaicElementPreview = {
            id: "",
            indexForBacklight: Math.random().toString(),
            type: selectedElementType,
            startColumn: +columnStart,
            width: +width,
            startRow: +rowStart,
            height: +height,
            staticImageName: MosaicElementType.Image == selectedElementType ? uploadedImageName : "",
            staticImageUrl: MosaicElementType.Image == selectedElementType ? uploadedImageUrl : "",
            recourceName: MosaicElementType.WebViewLocal == selectedElementType ? zipFileName : "",
            clockBackgroundColour: MosaicElementType.Clock == selectedElementType ? bgColor : "",
            clockTextColour: MosaicElementType.Clock == selectedElementType ? textColor : "",
            clockTextFormat: MosaicElementType.Clock == selectedElementType ? selectedTimeFormat : "",
            mediaLoopMedias: mediaLoopList.map(it => {
                return {
                    id: it.id,
                    duration: it.duration,
                    name: it.name
                }
            }),
            mediaLoopMediasInfo:mediaLoopList.map(it => {
                return {
                    id: it.id,
                    duration: it.duration,
                    name: it.name
                }
            }),
            name: selectedElementType === MosaicElementType.Rss ? '' : nameElement,
            url: selectedElementType === MosaicElementType.Rss ? '' : youtubeURL,
            mute: mute,
            youtubeIsLive: youtubeIsLive,
        }

        switch(selectedElementType){
            case MosaicElementType.Rss:
                newMosaicElement.parameters = { 
                    type: 'rss', 
                    url: youtubeURL,
                    numberOfLines: normalizedRssLines,
                    maxItems: normalizedRssMaxItems,
                    backgroundImageRecourceBlobName: rssBackgroundImageRecourceBlobName,
                    fallbackImageRecourceBlobName: rssFallbackImageRecourceBlobName,
                    colourOfHeader: rssHeaderColor,
                    colourOfText: rssTextColor,
                    // Header Typography
                    headerFont: rssHeaderFont,
                    headerFontSize: +rssHeaderFontSize || 24,
                    headerFontStyle: rssHeaderFontStyle,
                    headerAlignment: rssHeaderAlignment,
                    // Text Typography
                    textFont: rssTextFont,
                    textFontSize: +rssTextFontSize || 16,
                    textFontStyle: rssTextFontStyle,
                    textAlignment: rssTextAlignment,
                    hideText: rssHideText,
                    // Margins and Spacing
                    marginTop: +rssMarginTop || 10,
                    marginRight: +rssMarginRight || 10,
                    marginLeft: +rssMarginLeft || 10,
                    spacingBetweenTextAndHeader: +rssSpacingBetweenTextAndHeader || 5,
                    spacingBetweenItems: +rssSpacingBetweenItems || 10,
                    // Update and Rotation Settings
                    updateIntervalMinutes: +rssUpdateIntervalMinutes || 30,
                    rotationIntervalSeconds: rssRotationIntervalSeconds === '' ? undefined : +rssRotationIntervalSeconds,
                    rotateInRandom: rssRotateInRandom,
                    loadLastXHours: rssLoadLastXHours === '' ? undefined : +rssLoadLastXHours
                };
        }
        
        if(checkIsVideoLayerElement(newMosaicElement.type)){
            setMosaicVideoLayer([...mosaicVideoLayer, newMosaicElement])
        }
        else {
            setMosaicWidgetLayer([...mosaicWidgetLayer, newMosaicElement])
        }
        
        setColumnStart(1);
        setWidth(1);
        setRowStart(1);
        setHeight(1);
        setUploadedImageName('');
        setUploadedImageUrl('');
        setBgColor('#ffffff');
        setTextColor('#000000');
        setSelectedTimeFormat('HH:mm:ss, dd.MM.yyyy');
        setRssNumberOfLines(1);
        setRssMaxItems(1);
        setRssHeaderColor('#ffffff');
        setRssTextColor('#000000');
        setRssBackgroundImageRecourceBlobName('');
        setRssBackgroundImageUrl('');
        setRssFallbackImageRecourceBlobName('');
        setRssFallbackImageUrl('');
        // Reset RSS Typography - Header
        setRssHeaderFont(0);
        setRssHeaderFontSize(24);
        setRssHeaderFontStyle(0);
        setRssHeaderAlignment(0);
        // Reset RSS Typography - Text
        setRssTextFont(0);
        setRssTextFontSize(16);
        setRssTextFontStyle(0);
        setRssTextAlignment(0);
        setRssHideText(false);
        // Reset RSS Margins and Spacing
        setRssMarginTop(10);
        setRssMarginRight(10);
        setRssMarginLeft(10);
        setRssSpacingBetweenTextAndHeader(5);
        setRssSpacingBetweenItems(10);
        // Reset RSS Update and Rotation Settings
        setRssUpdateIntervalMinutes(30);
        setRssRotationIntervalSeconds('');
        setRssRotateInRandom(false);
        setRssLoadLastXHours('');
        setMediaLoopList([]);
        setNameElement('');
        setYoutubeURL('');
        setMute(true);
        setYoutubeIsLive(true);
        setIsMosaicElementsChange(true)
        setZipFileName("")
        setIsLocal(true)
    }

    const handleWeatherWidgetAdd = (data: WeatherWidgetData) => {
        const newMosaicElement: MosaicElementPreview = {
            id: "",
            indexForBacklight: Math.random().toString(),
            type: data.type,
            startColumn: data.startColumn,
            width: data.width,
            startRow: data.startRow,
            height: data.height,
            name: data.name,
            recourceName: "",
            parameters: data.parameters
        };
        
        setMosaicWidgetLayer([...mosaicWidgetLayer, newMosaicElement]);
        
        setColumnStart(1);
        setWidth(1);
        setRowStart(1);
        setHeight(1);
        setWeatherBackgroundImageUrl('');
        setIsMosaicElementsChange(true);
    }

    const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            setIsLoading(true);
            formData.append("Recource", event.target.files[0] );
            let res = await uploadImage(formData);
            if(res.status === 200){
                setUploadedImageName(res.data.data.name);
                setUploadedImageUrl(res.data.data.url);
                setNameElement(res.data.data.name);
                event.target.value = '';
            }
            setIsLoading(false);
        }
    }

    const onRssBackgroundImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            setIsLoading(true);
            formData.append("Recource", event.target.files[0] );
            let res = await uploadImage(formData);
            if(res.status === 200){
                setRssBackgroundImageRecourceBlobName(res.data.data.name);
                setRssBackgroundImageUrl(res.data.data.url);
                event.target.value = '';
            }
            setIsLoading(false);
        }
    }

    const onRssFallbackImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            setIsLoading(true);
            formData.append("Recource", event.target.files[0] );
            let res = await uploadImage(formData);
            if(res.status === 200){
                setRssFallbackImageRecourceBlobName(res.data.data.name);
                setRssFallbackImageUrl(res.data.data.url);
                event.target.value = '';
            }
            setIsLoading(false);
        }
    }

    const onFileChangeMediaLoop = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            if(event.target.files[0].size > 8*1024*1024 && event.target.files[0].type != 'video/mp4'){
                alert("Max supported size for image is 8Mb");
                return;
            }

            const formData = new FormData();
            setIsLoading(true);
            formData.append("Recource", event.target.files[0] );
            let res = await uploadImage(formData);
            if(res.status === 200){
                setIsPlaylistMediaDownloaded(true);
                if(event.target.files[0].type != 'video/mp4'){
                    setIsPlaylistVideoDownloaded(false);
                    setNameElement(res.data.data.originalName);
                    setUploadedMediaLoopImage({
                        id: res.data.data.id,
                        name: res.data.data.originalName,
                    });
                    event.target.value = '';
                }
                else {
                    setIsPlaylistVideoDownloaded(true);
                    setNameElement(res.data.data.originalName);
                    setUploadedMediaLoopImage({
                        id: res.data.data.id,
                        name: res.data.data.originalName,
                    });
                    event.target.value = '';
                }
            }
            setIsLoading(false);
        }
    }

    const addToMediaLoopList = () => {
        setMediaLoopList([...mediaLoopList,{
            id: uploadedMediaLoopImage.id,
            name: nameElement,
            duration: isPlaylistVideoDownloaded ? 0 : imageDuration
        }])
        setUploadedMediaLoopImage(mockUploadedLoopImage);
        setImageDuration(10);
        setNameElement('');
        setIsPlaylistVideoDownloaded(false);
        setIsPlaylistMediaDownloaded(false);
    }

    const resetMediaLoopListItem = () => {
        setIsPlaylistVideoDownloaded(false);
        setIsPlaylistMediaDownloaded(false);
        setUploadedMediaLoopImage(mockUploadedLoopImage);
        setImageDuration(10);
        setNameElement('');
    }

    const removeMosaicElement = (id : Guid) => {
        setMosaicValidationErrorText('');
        setMosaicVideoLayer(mosaicVideoLayer.filter(el => {
            if(el.id != ""){
                return el.id != id
            } else {
                return el.indexForBacklight != id
            }
        }))
        setMosaicWidgetLayer(mosaicWidgetLayer.filter(el => {
            if(el.id != ""){
                return el.id != id
            } else {
                return el.indexForBacklight != id
            }
        }))
        setIsMosaicElementsChange(true);
    }

    const renderMosaicElementsToList = (mosaic:MosaicElementPreview[]) => {
        return mosaic.map( (it) => {
            let isForBacklight, curIdentifier: Guid
            if(it.id != ""){
                isForBacklight = it.id === idForBackLight;
                curIdentifier = it.id
            } else {
                isForBacklight = it.indexForBacklight === idForBackLight
                curIdentifier = it.indexForBacklight === undefined ? '' : it.indexForBacklight
            }
            let mosaicListItemClasses = `mosaic-list-item ${isForBacklight && 'backlight'}`;
            return <div className={mosaicListItemClasses} key={curIdentifier} onClick={()=>clickForBacklightCell(curIdentifier)}> 
                {getIconByType(it.type)}
                <div className="mosaic-list-content">
                    <p><b>{getMosaicElementTypeName(it.type)}</b></p>
                    <p>Column Start:{it.startColumn} Width:{it.width}</p>
                    <p>Row Start:{it.startRow} Height:{it.height}</p>
                    {it.type === MosaicElementType.Image && <>
                        <img className="mosaic-img" src={it.staticImageUrl} alt="" />
                        <p>Name: {it.name}</p>
                    </>} 
                    {it.type === MosaicElementType.Clock && <span>Format: {getTimeFormatName(it.clockTextFormat)}</span>} 
                    {it.type === MosaicElementType.MediaLoop && <ol>
                        {it.mediaLoopMedias?.map(it2 => {
                            return <li key={it2.id}>{it2.name}</li>
                        })}
                        </ol>} 
                    {it.type === MosaicElementType.Youtube && <>
                        <p>Name: {it.name}</p>
                        <p style={{'wordBreak':'break-all'}}>URL: {it.url}</p>
                        {it.mute && <p>Muted</p>}
                        {it.youtubeIsLive && <p>Live</p>}
                    </>} 
                    {it.type === MosaicElementType.WebView && <>
                        <p>Name: {it.name}</p>
                        <p style={{'wordBreak':'break-all'}}>URL: {it.url}</p>
                    </>} 
                    {it.type === MosaicElementType.WebViewLocal && <>
                        <p>Name: {it.name}</p>
                    </>}
                    {it.type === MosaicElementType.Rss && it.parameters?.type === 'rss' && <>
                        <p style={{'wordBreak':'break-all'}}>URL: {it.parameters.url || it.url}</p>
                        {it.parameters.numberOfLines && <p>Lines: {it.parameters.numberOfLines}</p>}
                        {it.parameters.maxItems && <p>Maximum Number of Items: {it.parameters.maxItems}</p>}
                        {it.parameters.colourOfHeader && <p>Header Color: {it.parameters.colourOfHeader}</p>}
                        {it.parameters.colourOfText && <p>Text Color: {it.parameters.colourOfText}</p>}
                        {it.parameters.headerFont !== undefined && <p>Header Font: {FontFamilies[it.parameters.headerFont]?.name}</p>}
                        {it.parameters.headerFontSize && <p>Header Font Size: {it.parameters.headerFontSize}</p>}
                        {it.parameters.headerFontStyle !== undefined && <p>Header Font Style: {FontStyles[it.parameters.headerFontStyle]?.name}</p>}
                        {it.parameters.headerAlignment !== undefined && <p>Header Alignment: {TextAlignments[it.parameters.headerAlignment]?.name}</p>}
                        {it.parameters.textFont !== undefined && <p>Text Font: {FontFamilies[it.parameters.textFont]?.name}</p>}
                        {it.parameters.textFontSize && <p>Text Font Size: {it.parameters.textFontSize}</p>}
                        {it.parameters.textFontStyle !== undefined && <p>Text Font Style: {FontStyles[it.parameters.textFontStyle]?.name}</p>}
                        {it.parameters.textAlignment !== undefined && <p>Text Alignment: {TextAlignments[it.parameters.textAlignment]?.name}</p>}
                        {it.parameters.hideText && <p>Hide Text: Yes</p>}
                        {it.parameters.marginTop !== undefined && <p>Margin Top: {it.parameters.marginTop}</p>}
                        {it.parameters.marginRight !== undefined && <p>Margin Right: {it.parameters.marginRight}</p>}
                        {it.parameters.marginLeft !== undefined && <p>Margin Left: {it.parameters.marginLeft}</p>}
                        {it.parameters.spacingBetweenTextAndHeader !== undefined && <p>Spacing: {it.parameters.spacingBetweenTextAndHeader}</p>}
                        {it.parameters.spacingBetweenItems !== undefined && <p>Item Spacing: {it.parameters.spacingBetweenItems}</p>}
                        {it.parameters.updateIntervalMinutes && <p>Update Interval: {it.parameters.updateIntervalMinutes} min</p>}
                        {it.parameters.rotationIntervalSeconds && <p>Rotation Interval: {it.parameters.rotationIntervalSeconds} sec</p>}
                        {it.parameters.rotateInRandom && <p>Random Rotation: Yes</p>}
                        {it.parameters.loadLastXHours && <p>Load Last: {it.parameters.loadLastXHours} hours</p>}
                    </>}
                    {it.type === MosaicElementType.Weather && it.parameters?.type === 'weather' && (
                        <WeatherWidgetListItem parameters={it.parameters} name={it.name} />
                    )}
                </div>
                <IconButton tooltipText="Close" type="cross" onClick={()=>removeMosaicElement(curIdentifier)} />
            </div>
        })
    }

    const changeElementType = (type: MosaicElementType) => {
        setNameElement('');
        setSelectedElementType(type);
    }

    const renderElementTypeTab = (type: MosaicElementType) => {
        return  <span className={`type-item ${selectedElementType === type ? 'active' : ''}`} onClick={()=>{changeElementType(type)}}>
                    {getIconByType(type)}
                    {getMosaicElementTypeName(type)}
                </span>
    }

    const renderElemntTabTilePositionControls = (rowClassnames: string, type: MosaicElementType) => {
        return <>
                <div className={rowClassnames}>
                    {isElementOutOfLimit(type) && <span className="info-message">{`You can have ${getElementLimits(type)} elements of this type`}</span>}
                    <FormRow>
                        <FormInputNumber 
                            id="column-start"
                            title="Column Start"
                            isError={false}
                            errorMessage="Please enter column start"
                            onChangeValue={value => {
                                if(value === "" || +value < 1 ) setColumnStart('')
                                else setColumnStart(+value)
                            }}
                            onBlurFires={value => {
                                value == "" && setColumnStart(1)
                            }}
                            onChange={()=>{}}
                            value={columnStart}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber 
                            id="column-end"
                            title="Width"
                            isError={false}
                            errorMessage="Please enter width"
                            onChangeValue={value => {
                                if(value === "" || +value < 1 ) setWidth('')
                                else setWidth(+value)
                            }}
                            onBlurFires={value => {
                                value == "" && setWidth(1)
                            }}
                            onChange={()=>{}}
                            value={width}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber 
                            id="row-start"
                            title="Row Start"
                            isError={false}
                            errorMessage="Please enter row start"
                            onChangeValue={value => {
                                if(value === "" || +value < 1 ) setRowStart('')
                                else setRowStart(+value)
                            }}
                            onBlurFires={value => {
                                value == "" && setRowStart(1)
                            }}
                            onChange={()=>{}}
                            value={rowStart}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber 
                            id="row-end"
                            title="Height"
                            isError={false}
                            errorMessage="Please enter height"
                            onChangeValue={value => {
                                if(value === "" || +value < 1 ) setHeight('')
                                else setHeight(+value)
                            }}
                            onBlurFires={value => {
                                value == "" && setHeight(1)
                            }}
                            onChange={()=>{}}
                            value={height}
                        />
                    </FormRow>
                </div>
                {mosaicValidationErrorText && <span className="error">{mosaicValidationErrorText}</span>}
        </>
    }

    const renderElementTypeTabContent = (type: MosaicElementType, isOutOfLimit:boolean) => {
        let fixedHeight = '180px';
        let rowClassnames = `mosaic-settings-add-elem ${isOutOfLimit ? 'out-of-limit' : ''}`
        switch(type){
            case MosaicElementType.Main: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                </div>            
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Main Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType)} />&nbsp;
                </div>
            </>
            case MosaicElementType.Image: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    <div className="image-widget-controls">
                        <FormRow>
                            <div style={{'paddingTop': '15px'}}>
                                {!isElementOutOfLimit(selectedElementType) && <SelectAvatarButton id="mosaic-img" title="Upload Image" onChange={onFileChange}/>}
                            </div>
                        </FormRow>
                        {uploadedImageName && <FormRow>
                            <FormInput 
                                errorMessage = "Please enter name"
                                id = "image_name"
                                isError = {false}
                                title = "Name"
                                onChange = {(e)=>{setNameElement(e.target.value)}}
                                value = {nameElement}
                            />
                        </FormRow>}
                    </div>
                </div>       
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Image Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || !uploadedImageUrl || !nameElement} />&nbsp;
                    {!isElementOutOfLimit(selectedElementType) && !uploadedImageUrl && <span>Please Upload Image</span>}
                </div>
            </>          
            case MosaicElementType.Clock: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    {!isElementOutOfLimit(selectedElementType) && <div className="color-group">
                        <FormRow>
                            <FormSelect
                                id="time-format"
                                title="Time Format"
                                selectedValue={selectedTimeFormat}
                                isError={false}
                                errorMessage="Error"
                                options={TimeFormats}
                                onChange={setSelectedTimeFormat}
                                hideDefaultValue={true}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInputColorpicker 
                                id="bg-color"
                                title="Background Color"
                                isError={false}
                                errorMessage="Please enter bg color"
                                onChangeValue={value => setBgColor(value)}
                                onChange={()=>{}}
                                value={bgColor}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInputColorpicker 
                                id="text-color"
                                title="Text Color"
                                isError={false}
                                errorMessage="Please enter text color"
                                onChangeValue={value => setTextColor(value)}
                                onChange={()=>{}}
                                value={textColor}
                            />
                        </FormRow>
                    </div>
                    }
                </div>
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Clock Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || !!!selectedTimeFormat} />&nbsp;
                    {!isElementOutOfLimit(selectedElementType) && !!!selectedTimeFormat && <span>Please Select Time Format</span>}
                </div>       
            </>   
            case MosaicElementType.MediaLoop: return <>
                <div style={{'minHeight': fixedHeight, 'paddingBottom':'1px'}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    <div className="d-flex align-items-end medialoop-widget">
                       
                    {!isPlaylistMediaDownloaded && <FormRow>
                        {!isElementOutOfLimit(selectedElementType) && <SelectFileButton title="Upload Media" onChange={onFileChangeMediaLoop}/>}
                    </FormRow>}
                    {isPlaylistMediaDownloaded && <>
                        {!isPlaylistVideoDownloaded && <FormRow>
                            <FormInputNumber 
                                id="image-duration"
                                title="Image Duration (seconds)"
                                isError={false}
                                errorMessage="Please enter image duration"
                                onChangeValue={value => setImageDuration(+value)}
                                onChange={()=>{}}
                                value={imageDuration}
                            />
                        </FormRow>}
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter name"
                                id = "playlistItem_name"
                                isError = {false}
                                title = "Name"
                                onChange = {(e)=>{setNameElement(e.target.value)}}
                                value = {nameElement}
                            />
                        </FormRow>
                        <FormRow>
                            <Button color="gray"  label="Cancel" onClick={resetMediaLoopListItem} />
                        </FormRow>
                        <FormRow>
                            <Button color="green"  label="Add To List" onClick={addToMediaLoopList} isDisabled={!nameElement} />
                        </FormRow>
                    </>}
                    </div>
                    <div className="sort-media-loop">
                        <ReactSortable 
                            list={mediaLoopList}
                            setList={(newState) => { onDrop(newState) }}
                            tag="div"
                        >
                            {renderMediaLoopItems(mediaLoopList)}
                        </ReactSortable>
                    </div>
                </div>       
                <div className="mosaic-settings-add-elem align-items-center playlist-mute-pos" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Playlist Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || !!!mediaLoopList.length} />
                    {!isElementOutOfLimit(selectedElementType) && !!!mediaLoopList.length && <span>Please Upload Media</span>}
                    <div className="mute-container">
                        <div className="block">
                            <FormCheckbox id="mute-playlist-status" checked={mute} onChange={setMute} />
                            <span className="mute-block">
                                {mute ? <span className="mute-status online">Mute</span> : <span className="current-status offline">Mute</span>}
                            </span>
                        </div>
                    </div>
                </div>
            </>    
            case MosaicElementType.Youtube: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    {!isElementOutOfLimit(selectedElementType) && <div className="youtube-widget">
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter name"
                                id = "yotube_name"
                                isError = {false}
                                title = "Name"
                                onChange = {(e)=>{setNameElement(e.target.value)}}
                                value = {nameElement}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter url"
                                id = "yotube_url"
                                isError = {false}
                                title = "URL"
                                onChange = {(e)=>{setYoutubeURL(e.target.value)}}
                                value = {youtubeURL}
                            />
                        </FormRow>
                        <div className="mute-container">
                            <div className="block">
                                <FormCheckbox id="mute-youtube-status" checked={mute} onChange={setMute} />
                                <span className="mute-block">
                                    {mute ? <span className="mute-status online">Mute</span> : <span className="current-status offline">Mute</span>}
                                </span>
                            </div>
                            <div className="block">
                                <FormCheckbox id="live-playlist-status" checked={youtubeIsLive} onChange={setYoutubeIsLive} />
                                <span className="live-block">
                                    {youtubeIsLive ? <span className="live-status online">Live</span> : <span className="current-status offline">Live</span>}
                                </span>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Youtube Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || nameElement === '' || youtubeURL ===''} />
                </div>       
            </>        
            case MosaicElementType.WebView: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    {!isElementOutOfLimit(selectedElementType) && <div className="webview-widget d-flex gap15">
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter name"
                                id = "webview_name"
                                isError = {false}
                                title = "Name"
                                onChange = {(e)=>{setNameElement(e.target.value)}}
                                value = {nameElement}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter url"
                                id = "webview_url"
                                isError = {false}
                                title = "URL"
                                onChange = {(e)=>{setYoutubeURL(e.target.value)}}
                                value = {youtubeURL}
                            />
                        </FormRow>
                        
                    </div>
                    }
                </div>
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Webview Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || nameElement === '' || youtubeURL ===''} />
                </div>       
            </>     
            case MosaicElementType.Rss: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    {!isElementOutOfLimit(selectedElementType) && <div className="webview-widget" style={{'display':'block'}}>
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter url"
                                id = "rss_url"
                                isError = {false}
                                title = "URL"
                                onChange = {(e)=>{setYoutubeURL(e.target.value)}}
                                value = {youtubeURL}
                            />
                        </FormRow>
                        <div className="d-flex gap15">
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_lines"
                                    title="Number of Lines"
                                    isError={false}
                                    errorMessage="Please enter number of lines"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 1 ) setRssNumberOfLines('')
                                        else setRssNumberOfLines(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssNumberOfLines(1)
                                    }}
                                    onChange={()=>{}}
                                    value={rssNumberOfLines}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_max_items"
                                    title="Maximum Number of Items"
                                    isError={false}
                                    errorMessage="Please enter maximum number of items"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 1 ) setRssMaxItems('')
                                        else setRssMaxItems(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssMaxItems(1)
                                    }}
                                    onChange={()=>{}}
                                    value={rssMaxItems}
                                />
                            </FormRow>
                        </div>
                        <FormRow>
                            <div style={{'paddingTop': '15px'}}>
                                {!isElementOutOfLimit(selectedElementType) && <SelectAvatarButton id="rss-bg" title="Upload Background" onChange={onRssBackgroundImageChange}/>}
                            </div>
                        </FormRow>
                        <FormRow>
                            {rssBackgroundImageUrl && <img className="mosaic-img" src={rssBackgroundImageUrl} alt="" style={{'maxHeight': fixedHeight, 'width':'auto', 'objectFit':'contain'}} />}
                        </FormRow>
                        <FormRow>
                            <div style={{'paddingTop': '15px'}}>
                                {!isElementOutOfLimit(selectedElementType) && <SelectAvatarButton id="rss-fallback" title="Upload Fallback Image" onChange={onRssFallbackImageChange}/>}
                            </div>
                        </FormRow>
                        <FormRow>
                            {rssFallbackImageUrl && <img className="mosaic-img" src={rssFallbackImageUrl} alt="" style={{'maxHeight': fixedHeight, 'width':'auto', 'objectFit':'contain'}} />}
                        </FormRow>
                        
                        <h4 style={{'marginTop': '20px', 'marginBottom': '10px'}}>Header Typography</h4>
                        <div className="d-flex gap15">
                            <FormRow>
                                <FormInputColorpicker 
                                    id="rss_header_color"
                                    title="Header Color"
                                    isError={false}
                                    errorMessage="Please enter header color"
                                    onChangeValue={value => setRssHeaderColor(value)}
                                    onChange={()=>{}}
                                    value={rssHeaderColor}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_header_font"
                                    title="Header Font"
                                    selectedValue={rssHeaderFont.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={FontFamilies}
                                    onChange={(value) => setRssHeaderFont(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_header_font_size"
                                    title="Header Font Size"
                                    selectedValue={rssHeaderFontSize.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={HeaderFontSizes}
                                    onChange={(value) => setRssHeaderFontSize(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_header_font_style"
                                    title="Header Font Style"
                                    selectedValue={rssHeaderFontStyle.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={FontStyles}
                                    onChange={(value) => setRssHeaderFontStyle(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_header_alignment"
                                    title="Header Alignment"
                                    selectedValue={rssHeaderAlignment.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={TextAlignments}
                                    onChange={(value) => setRssHeaderAlignment(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                        </div>
                        
                        <h4 style={{'marginTop': '20px', 'marginBottom': '10px'}}>Text Typography</h4>
                        <div className="d-flex gap15">
                            <FormRow>
                                <FormInputColorpicker 
                                    id="rss_text_color"
                                    title="Text Color"
                                    isError={false}
                                    errorMessage="Please enter text color"
                                    onChangeValue={value => setRssTextColor(value)}
                                    onChange={()=>{}}
                                    value={rssTextColor}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_text_font"
                                    title="Text Font"
                                    selectedValue={rssTextFont.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={FontFamilies}
                                    onChange={(value) => setRssTextFont(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_text_font_size"
                                    title="Text Font Size"
                                    selectedValue={rssTextFontSize.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={TextFontSizes}
                                    onChange={(value) => setRssTextFontSize(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_text_font_style"
                                    title="Text Font Style"
                                    selectedValue={rssTextFontStyle.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={FontStyles}
                                    onChange={(value) => setRssTextFontStyle(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                            <FormRow>
                                <FormSelect
                                    id="rss_text_alignment"
                                    title="Text Alignment"
                                    selectedValue={rssTextAlignment.toString()}
                                    isError={false}
                                    errorMessage=""
                                    options={TextAlignments}
                                    onChange={(value) => setRssTextAlignment(+value)}
                                    hideDefaultValue={true}
                                />
                            </FormRow>
                        </div>
                        <FormRow>
                            <div style={{'paddingTop': '10px', 'display': 'flex', 'alignItems': 'center', 'gap': '10px'}}>
                                <FormCheckbox id="rss-hide-text" checked={rssHideText} onChange={setRssHideText} />
                                <label htmlFor="rss-hide-text">Hide Text (show only titles)</label>
                            </div>
                        </FormRow>
                        
                        <h4 style={{'marginTop': '20px', 'marginBottom': '10px'}}>Margins and Spacing (px)</h4>
                        <div className="d-flex gap15">
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_margin_top"
                                    title="Margin Top"
                                    isError={false}
                                    errorMessage="Please enter margin top"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 0 ) setRssMarginTop('')
                                        else setRssMarginTop(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssMarginTop(10)
                                    }}
                                    onChange={()=>{}}
                                    value={rssMarginTop}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_margin_right"
                                    title="Margin Right"
                                    isError={false}
                                    errorMessage="Please enter margin right"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 0 ) setRssMarginRight('')
                                        else setRssMarginRight(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssMarginRight(10)
                                    }}
                                    onChange={()=>{}}
                                    value={rssMarginRight}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_margin_left"
                                    title="Margin Left"
                                    isError={false}
                                    errorMessage="Please enter margin left"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 0 ) setRssMarginLeft('')
                                        else setRssMarginLeft(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssMarginLeft(10)
                                    }}
                                    onChange={()=>{}}
                                    value={rssMarginLeft}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_spacing_between"
                                    title="Text and Header Spacing"
                                    isError={false}
                                    errorMessage="Please enter spacing"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 0 ) setRssSpacingBetweenTextAndHeader('')
                                        else setRssSpacingBetweenTextAndHeader(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssSpacingBetweenTextAndHeader(5)
                                    }}
                                    onChange={()=>{}}
                                    value={rssSpacingBetweenTextAndHeader}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_spacing_between_items"
                                    title="Spacing Between Items"
                                    isError={false}
                                    errorMessage="Please enter spacing between items"
                                    onChangeValue={ value => {setRssSpacingBetweenItems(Math.floor(+value))}}
                                    onBlurFires={ value => {value == "" && setRssSpacingBetweenItems(10) }}
                                    onChange={()=>{}}
                                    value={rssSpacingBetweenItems}
                                />
                            </FormRow>
                        </div>
                        
                        <h4 style={{'marginTop': '20px', 'marginBottom': '10px'}}>Update and Rotation Settings</h4>
                        <div className="d-flex gap15">
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_update_interval"
                                    title="Update Interval (minutes)"
                                    isError={false}
                                    errorMessage="Please enter update interval"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 1 ) setRssUpdateIntervalMinutes('')
                                        else setRssUpdateIntervalMinutes(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {
                                        value == "" && setRssUpdateIntervalMinutes(30)
                                    }}
                                    onChange={()=>{}}
                                    value={rssUpdateIntervalMinutes}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_rotation_interval"
                                    title="Rotation Interval (seconds, optional)"
                                    isError={false}
                                    errorMessage="Please enter rotation interval"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 1 ) setRssRotationIntervalSeconds('')
                                        else setRssRotationIntervalSeconds(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {}}
                                    onChange={()=>{}}
                                    value={rssRotationIntervalSeconds}
                                />
                            </FormRow>
                            <FormRow>
                                <FormInputNumber 
                                    id="rss_load_last_hours"
                                    title="Load Last X Hours (optional)"
                                    isError={false}
                                    errorMessage="Please enter hours"
                                    onChangeValue={value => {
                                        if(value === "" || +value < 1 ) setRssLoadLastXHours('')
                                        else setRssLoadLastXHours(Math.floor(+value))
                                    }}
                                    onBlurFires={value => {}}
                                    onChange={()=>{}}
                                    value={rssLoadLastXHours}
                                />
                            </FormRow>
                        </div>
                        <FormRow>
                            <div style={{'paddingTop': '10px', 'display': 'flex', 'alignItems': 'center', 'gap': '10px'}}>
                                <FormCheckbox id="rss-rotate-random" checked={rssRotateInRandom} onChange={setRssRotateInRandom} />
                                <label htmlFor="rss-rotate-random">Rotate in Random Order</label>
                            </div>
                        </FormRow>
                    </div>
                    }
                </div>
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add RSS Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || youtubeURL ==='' || !!!+rssNumberOfLines || !!!+rssMaxItems} />
                </div>       
            </>     
            case MosaicElementType.WebViewLocal: return <>
                <div style={{'minHeight': fixedHeight}}>
                    {renderElemntTabTilePositionControls(rowClassnames, type)}
                    {!isElementOutOfLimit(selectedElementType) && <div className="d-flex gap15">
                        <FormRow>
                            <div className="pt-20 d-flex">
                            <label htmlFor="zip-upload" className="btn primary_btn w-100">Upload Zip</label>
                            <input id="zip-upload" type="file" name="zip-upload" accept=".zip" onChange={onUploadZipArchieve}/>
                            </div>
                        </FormRow>
                        
                         <FormRow>
                            {zipFileName &&<>
                                <FormInput 
                                    errorMessage = ""
                                    id = "zipFileName"
                                    isError = {false}
                                    title = "Name"
                                    onChange = {(e)=>{setNameElement(e.target.value)}}
                                    value = {nameElement}
                                />
                                <div className="d-flex align-items-center pt-20">
                                    <FormCheckbox id="download-locally" checked={isLocal} onChange={()=>{}} isDisabled={true} />
                                    <span className="status-block">
                                        {isLocal ? <span className="current-status online">&nbsp;Download locally </span> 
                                        : <span className="current-status offline">&nbsp;Download locally</span>}
                                    </span>
                                </div>
                            </>}
                        </FormRow>
                        
                    </div>
                    }
                </div>
                <div className="mosaic-settings-add-elem align-items-center" style={{'marginBottom': '15px'}}>
                    <Button color="green"  label="Add Webview Widget" onClick={addLocalNewMosaicElem} isDisabled={isElementOutOfLimit(selectedElementType) || !zipFileName} />
                </div>       
            </>
            case MosaicElementType.Weather: return <WeatherWidget
                columnStart={columnStart}
                width={width}
                rowStart={rowStart}
                height={height}
                onColumnStartChange={setColumnStart}
                onWidthChange={setWidth}
                onRowStartChange={setRowStart}
                onHeightChange={setHeight}
                isOutOfLimit={isElementOutOfLimit(MosaicElementType.Weather)}
                maxElements={getElementLimits(MosaicElementType.Weather)}
                currentCount={getElementsCountByType(MosaicElementType.Weather)}
                onAddWidget={handleWeatherWidgetAdd}
                validationError={mosaicValidationErrorText}
                onBackgroundImageUrlChange={setWeatherBackgroundImageUrl}
            />      
        }
    }

    const renderMediaLoopItems = (items: IMediaLoopItem[]) => {
        return items.map(it => {
            return <p key={it.id}>{it.name} <IconButton tooltipText="Close" type="cross" onClick={()=>removeFromMediaLoopList(it.id)} /></p>
        })
    }

    const removeFromMediaLoopList = (id: string) => {
        setMediaLoopList([...mediaLoopList.filter(it => it.id != id)]);
    }

    const onDrop = async (newOrderedMedia: IMediaLoopItem[]) => {
        setMediaLoopList([...newOrderedMedia])
    }

    const onUploadZipArchieve = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            setIsLoading(true);
            formData.append("Recource", event.target.files[0] );
            let res = await uploadImage(formData);
            if(res.status === 200){
                setZipFileName(res.data.data.name);
                setNameElement(res.data.data.name);
                event.target.value = '';
            }
            setIsLoading(false);
        }
    }

    return <InnerLayout 
        activeTab="skins" 
        logOut={logOut} 
        toogleCollapse={toogleCollapse}
        isCollapsed={isCollapsed}
        >
            <>
            <div className="mosaic-settings-block pt-50">
                <div className="mosaic-settings-row">
                    <h1>{mosaicConfig.name} ({mosaicConfig.columnNumber} x {mosaicConfig.rowNumber})</h1>
                </div>
                <div className="mosaic-settings-row">
                    <div className="type-content-block">
                        {renderElementTypeTab(MosaicElementType.Main)}
                        {renderElementTypeTab(MosaicElementType.Image)}
                        {renderElementTypeTab(MosaicElementType.Clock)}
                        {renderElementTypeTab(MosaicElementType.MediaLoop)}
                        {/* {renderElementTypeTab(MosaicElementType.Youtube)} */}
                        {renderElementTypeTab(MosaicElementType.WebView)}
                        {renderElementTypeTab(MosaicElementType.Rss)}
                        {renderElementTypeTab(MosaicElementType.WebViewLocal)}
                        {renderElementTypeTab(MosaicElementType.Weather)}
                    </div>
                    {renderElementTypeTabContent(selectedElementType, isElementOutOfLimit(selectedElementType))}
                </div>
            </div>
            <div className="mosaic">
                <div className="container-mosaic"   onClick={(e)=>{e.stopPropagation()}}>
                    <div className="wrapper-mosaic">
                        <div className="grid-container" 
                            ref={mosaicRef}
                            style={{ 
                                "--grid-column-width": `${mosaicConfig.gridColumnWidth}`, 
                                "--grid-column-height": `${mosaicConfig.gridColumnHeight}`,
                                "--column-number": `${mosaicConfig.columnNumber}`, 
                                "--row-number": `${mosaicConfig.rowNumber}`} as React.CSSProperties
                            }
                        >
                            {renderMosaicElements([...[...mosaicWidgetLayer].reverse(), ...mosaicVideoLayer])}
                            {renderElementPositionPreview()}
                        </div>
                        <div className="grid-container abs-pos" 
                            style={{ 
                                "--grid-column-width": `${mosaicConfig.gridColumnWidth}`, 
                                "--grid-column-height": `${mosaicConfig.gridColumnHeight}`,
                                "--column-number": `${mosaicConfig.columnNumber}`, 
                                "--row-number": `${mosaicConfig.rowNumber}`} as React.CSSProperties
                            }
                        >
                            {renderMosaicCells(mosaicConfig.columnNumber, mosaicConfig.rowNumber)}
                        </div>
                    </div>
                </div>
                
                <div className="mosaic-list"   onClick={(e)=>{e.stopPropagation()}}>
                    {mosaicVideoLayer.length != 0 ? <>
                        <h3>Video Layer</h3>
                        {renderMosaicElementsToList(mosaicVideoLayer)}
                    </> : null}
                    
                    {mosaicWidgetLayer.length != 0 ? <>
                        <h3 className="pt-10">Widget Layer</h3>
                        <ReactSortable 
                            list={mosaicWidgetLayer}
                            setList={(newState) => { setMosaicWidgetLayer(newState) }}
                            tag="div"
                            onEnd={() => {setIsMosaicElementsChange(true)}}
                        >
                            {renderMosaicElementsToList(mosaicWidgetLayer)}
                        </ReactSortable>
                    </> : null}

                    {mosaicValidationErrorText && <span className="error">{mosaicValidationErrorText}</span>}
                    {isMosaicElementsChange && <div className="mosaic-settings-add-elem" style={{'marginBottom': '15px'}}>
                        <Button color="green"  label="Save" onClick={updateMosaicTemplate} isDisabled={!!mosaicValidationErrorText} /> &nbsp;&nbsp;
                        <Button color="gray"  label="Discard" onClick={()=>{window.location.reload()}} />
                    </div>}
                </div>
            </div>
            <GlobalSpinner isShow={isLoading} />
            </>
    </InnerLayout>
}

export default withRouter(MosaicScreen);